import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-add-export-google-drive',
  templateUrl: './help-add-export-google-drive.component.html',
  styleUrls: ['./help-add-export-google-drive.component.scss']
})
export class HelpAddExportGoogleDriveComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
